import { BaseReducer } from 'reducers/util/baseReducer';

class UserReducer extends BaseReducer {
  constructor() {
    super({ constantGroup: 'users' });
  }
}

export const users = new UserReducer().store;



// WEBPACK FOOTER //
// ./src/reducers/api/users.js